

















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Typography from '@/components/Rain/Typography/Typography.vue'


@Component<BasicSelect>({
    components: {Typography}
})
export default class BasicSelect extends Vue {
    @Prop({type: Array, default: []})
    options !: [{ label: string, value: string }]

    @Prop({type: String, default: ''})
    value

    @Prop({type: String, default: ''})
    label
}
